import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        [theme.breakpoints.down("xs")]: {
            "&:not(:first-child)": {
                display: "none",
            },
        },
    },
    paper_title: {
        color: theme.palette.text.primary,
        fontSize: 24,
        margin: "0 auto 15px 0",
        fontWeight: 500,
        [theme.breakpoints.down("xs")]: {
            fontSize: 20,
        },
    },
    paper_number: {
        color: theme.palette.text.secondary,
        fontSize: 36,
        fontWeight: 600,
        [theme.breakpoints.down("xs")]: {
            fontSize: 30,
        },
    }
}))